import React from "react";
import { useMsal } from "@azure/msal-react";
import "../styles/platform.css";

function DisabledScreen() {
  const { instance, accounts } = useMsal();
  const user = accounts[0];

  const handleLogout = () => {
    instance.logoutRedirect({
      account: user,
      postLogoutRedirectUri: window.location.origin,
    });
  };

  return (
    <div className="waiting-screen waiting-screen--disabled">
      <div className="waiting-card">
        <div className="waiting-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="9" />
            <path d="M5.6 5.6l12.8 12.8" />
          </svg>
        </div>

        <span className="waiting-badge">Access Revoked</span>
        <h2>Account Deactivated</h2>
        <p className="waiting-message">
          Your account has been deactivated by the administrator.
          Please contact your manager or HR if you believe this is an error.
        </p>

        <div className="waiting-info">
          <span className="waiting-email">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="5" width="18" height="14" rx="2" />
              <path d="M3 7l9 6 9-6" />
            </svg>
            {user?.username}
          </span>
        </div>

        <p className="waiting-help">
          Need help? Reach out to <a href="mailto:hr@cloudtechon.com">HR Support</a>
        </p>

        <button className="waiting-logout-btn" onClick={handleLogout}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" />
          </svg>
          Sign Out
        </button>
      </div>
    </div>
  );
}

export default DisabledScreen;
